import { ElementType, forwardRef, Ref } from 'react';
import { Container as MuiContainer, ContainerProps } from '@mui/material';

export const Container = forwardRef(function Container<T extends ElementType = 'div'>(
  { children, ...otherProps }: ContainerProps<T>,
  ref: Ref<HTMLDivElement>,
) {
  return (
    <MuiContainer ref={ref} {...otherProps}>
      {children}
    </MuiContainer>
  );
});
